// IT UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Appartamenti e hotel',
  'site.currency': 'Valuta',
  'site.language': 'Lingua',
  'site.currencySelector': 'Selettore valuta',
  'site.languageSelector': 'Selettore lingua',
  'site.menu': 'Menu',
  'site.signIn': 'Accedi',
  'site.signOut': 'Esci',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Apri menu',
  'site.footer.copyright': 'Tutti i diritti riservati.',
  'site.footer.manageBooking': 'Gestisci la tua prenotazione',
  'site.footer.terms': 'Termini e condizioni',
  'site.footer.privacy': 'Informativa sulla privacy',
  'site.trust.bestPrice': 'Garanzia del miglior prezzo',
  'site.trust.bestPriceDesc': 'Ottieni le migliori tariffe.',
  'site.trust.flexibleBooking': 'Prenotazione flessibile',
  'site.trust.flexibleBookingDesc': 'Modifiche e cancellazioni facili.',
  'site.trust.securePayments': 'Pagamenti sicuri',
  'site.trust.securePaymentsDesc': 'Checkout affidabile e sicuro.',
  'site.trust.localSupport': 'Assistenza locale',
  'site.trust.localSupportDesc': 'Siamo qui per aiutarti in ogni momento.',
  'home.heroTitle': 'Trova il soggiorno perfetto',
  'home.inAustralia': 'in Australia',
  'home.heroSubtitle': 'Appartamenti e hotel per ogni tipo di soggiorno',
  'home.errorLoading': 'Impossibile caricare le strutture.',
  'home.noPropertiesTitle': 'Nessuna struttura disponibile al momento.',
  'home.noPropertiesDescription':
    'Prova a cercare una destinazione per scoprire i soggiorni disponibili.',
  'home.exploreStays': 'Esplora soggiorni',
  'home.property': 'struttura',
  'home.property_one': 'struttura',
  'home.property_other': 'strutture',
  'home.properties': 'strutture',
  'home.foundInAustralia': 'trovate in Australia',
  'search.errorLoading': 'Impossibile caricare la disponibilità. Riprova.',
  'search.noResults': 'Nessuna struttura corrisponde ai criteri di ricerca.',
  'search.mapFollow': 'Cerca mentre muovo la mappa',
  'search.chooseLocationTitle': 'Scegli una località',
  'search.chooseLocationDescription':
    'Seleziona una destinazione prima di cercare soggiorni disponibili.',
  'search.chooseDatesTitle': 'Scegli le date',
  'search.pastCheckIn': 'Il check-in non può essere nel passato.',
  'search.checkOutAfterCheckIn': 'Il check-out deve essere successivo al check-in.',
  'search.property': 'struttura',
  'search.property_one': 'struttura',
  'search.property_other': 'strutture',
  'search.properties': 'strutture',
  'search.found': 'trovate',
  'widget.where': 'Dove',
  'widget.location': 'Località',
  'widget.checkInOut': 'Check-in / Check-out',
  'widget.guests': 'Ospiti',
  'widget.rooms': 'Camere',
  'widget.promoCode': 'Codice promo',
  'widget.promoPlaceholderCompact': 'Aggiungi codice (opzionale)',
  'widget.promoPlaceholder': 'Opzionale',
  'widget.search': 'Cerca',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Adulto',
  'widget.adults': 'Adulti',
  'widget.child': 'Bambino',
  'widget.children': 'Bambini',
  'widget.decreaseAdults': 'Riduci adulti',
  'widget.increaseAdults': 'Aumenta adulti',
  'widget.decreaseChildren': 'Riduci bambini',
  'widget.increaseChildren': 'Aumenta bambini',
  'widget.room': 'Camera',
  'widget.adultOption': '{count} adulti',
  'widget.adultOption_one': '{count} adulto',
  'widget.adultOption_other': '{count} adulti',
  'widget.childOption': '{count} bambini',
  'widget.childOption_one': '{count} bambino',
  'widget.childOption_other': '{count} bambini',
  'widget.roomOption': '{count} camere',
  'widget.roomOption_one': '{count} camera',
  'widget.roomOption_other': '{count} camere',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Impossibile caricare le località. Riprova.',
  'widget.searchAria': 'Cerca disponibilità',
  'widget.dateErrorRequired': 'Seleziona sia la data di check-in che quella di check-out.',
  'widget.dateErrorPast': 'Il check-in non può essere nel passato.',
  'widget.dateErrorRange': 'Il check-out deve essere successivo al check-in.',
  'widget.dateRange.placeholder': 'Seleziona le date di check-in e check-out',
  'widget.dateRange.selectCheckout': 'Seleziona il check-out',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Selettore intervallo date check-in / check-out',
  'widget.dateRange.previousMonth': 'Mese precedente',
  'widget.dateRange.nextMonth': 'Mese successivo',
  'widget.dateRange.selectCheckIn': 'Seleziona la data di check-in',
  'widget.dateRange.selectCheckOut': 'Seleziona la data di check-out',
  'widget.dateRange.resetToday': 'Reimposta a oggi',
  'widget.dateRange.done': 'Fatto',
  'property.heroAlt': 'Immagine principale della struttura',
  'property.fallbackName': 'Struttura selezionata di {site}',
  'property.chooseRoom': 'Scegli la tua camera',
  'property.filterBy': 'Filtra per:',
  'property.filterAll': 'Tutte le camere',
  'property.filterStudios': 'Monolocali',
  'property.filter1Bed': '1 camera da letto',
  'property.filter2Bed': '2 camere da letto',
  'property.filterApartments': 'Appartamenti',
  'property.sortBy': 'Ordina per:',
  'property.sortRecommended': 'Consigliati',
  'property.sortPriceLow': 'Prezzo: dal più basso',
  'property.sortPriceHigh': 'Prezzo: dal più alto',
  'property.errorLoading': 'Impossibile caricare la disponibilità. Riprova.',
  'property.noRooms': 'Nessuna camera disponibile',
  'property.noRoomsDescription': 'Prova con altre date o numero di ospiti.',
  'property.totalForNights': 'Totale per {nights} notti',
  'property.perNight': 'a notte',
  'property.night': 'notte',
  'property.night_one': 'notte',
  'property.night_other': 'notti',
  'property.nights': 'notti',
  'property.freeCancellation': 'Cancellazione gratuita',
  'property.selectRoom': 'Seleziona camera',
  'property.selected': 'Selezionata',
  'property.continue': 'Continua',
  'property.previousPhoto': 'Foto precedente',
  'property.nextPhoto': 'Foto successiva',
  'property.addToWishlist': 'Aggiungi ai preferiti',
  'property.popularChoice': 'Scelta popolare',
  'property.showMore': 'Mostra di più',
  'property.showLess': 'Mostra meno',
  'property.maxOccupancy': 'Ospiti max:',
  'property.size': 'Dimensioni:',
  'property.bedType': 'Tipo di letto:',
  'property.roomAmenities': 'Servizi della camera',
  'property.showMoreAmenities': '+{count} altri',
  'property.guests': 'Ospiti',
  'property.adults': 'Adulti',
  'property.children': 'Bambini',
  'property.onlyRoomsLeft': 'Sono rimaste solo {count} camere',
  'property.onlyRoomsLeft_one': 'È rimasta solo {count} camera',
  'property.onlyRoomsLeft_other': 'Sono rimaste solo {count} camere',
  'property.lastBookedMinutes': 'Ultima prenotazione {count} minuti fa',
  'property.lastBookedMinutes_one': 'Ultima prenotazione {count} minuto fa',
  'property.lastBookedMinutes_other': 'Ultima prenotazione {count} minuti fa',
  'property.lastBookedHours': 'Ultima prenotazione {count} ore fa',
  'property.lastBookedHours_one': 'Ultima prenotazione {count} ora fa',
  'property.lastBookedHours_other': 'Ultima prenotazione {count} ore fa',
  'property.lastBookedDays': 'Ultima prenotazione {count} giorni fa',
  'property.lastBookedDays_one': 'Ultima prenotazione {count} giorno fa',
  'property.lastBookedDays_other': 'Ultima prenotazione {count} giorni fa',
  'property.checkInTime': 'Check-in {time}',
  'property.checkOutTime': 'Check-out {time}',
  'property.compare': 'Confronta',
  'property.taxesIncluded': 'a notte tasse e commissioni incluse',
  'property.chooseRate': 'Scegli la tua tariffa',
  'property.yourSelection': 'La tua selezione',
  'property.aboutRoom': 'Informazioni su questa camera',
  'property.roomDetails': 'Dettagli della camera',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Torna alle camere',
  'property.standardRate': 'Tariffa standard',
  'property.noPromotion': 'Nessuna promozione disponibile per questa tariffa.',
  'property.youSave': 'Risparmi ({percent}% di sconto) - {amount}',
  'property.inclusions': 'Inclusi:',
  'property.viewAllPhotos': 'Vedi tutte le foto',
  'property.seeOnMap': 'Vedi sulla mappa',
  'room.perNight': 'notte',
  'room.sleeps': 'Posti letto',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'disponibile',
  'room.select': 'Seleziona',
  'room.selected': 'Selezionata',
  'card.viewAvailability': 'Vedi disponibilità',
  'card.from': 'Da',
  'card.night': 'notte',
  'card.checkAvailability': 'Verifica disponibilità',
  'card.saveToFavourites': 'Salva nei preferiti',
  'card.ratingExcellent': 'Eccellente',
  'card.ratingVeryGood': 'Molto buono',
  'card.ratingGood': 'Buono',
  'card.ratingGuest': 'Giudizio degli ospiti',
  'guest.stepChooseRoom': 'Scegli la camera',
  'guest.stepGuestDetails': 'Dati ospite',
  'guest.stepPayment': 'Pagamento',
  'guest.stepConfirmation': 'Conferma',
  'guest.title': "Inserisci i dati dell'ospite",
  'guest.subtitle': 'Fornisci le tue informazioni.',
  'guest.firstName': 'Nome',
  'guest.lastName': 'Cognome',
  'guest.email': 'Email',
  'guest.emailHint': 'La conferma della prenotazione verrà inviata a questa email.',
  'guest.country': 'Paese',
  'guest.selectCountry': 'Seleziona il paese',
  'guest.searchCountry': 'Cerca paesi…',
  'guest.loadingCountries': 'Caricamento paesi…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Codice postale',
  'guest.phone': 'Numero di telefono',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Inserisci il numero di telefono',
  'guest.address': 'Indirizzo',
  'guest.city': 'Città',
  'guest.specialRequests': 'Richieste speciali (opzionale)',
  'guest.specialRequestsPlaceholder': 'Hai richieste speciali?',
  'guest.termsPrefix': 'Completando questa prenotazione, accetto i',
  'guest.terms': 'Termini e condizioni',
  'guest.termsAnd': 'e',
  'guest.privacy': 'Informativa sulla privacy',
  'guest.termsSuffix': ', e accetto le condizioni di prenotazione.',
  'guest.marketingOptOut': 'Non voglio ricevere messaggi di marketing.',
  'guest.cardVerify':
    'Verrà effettuata una verifica temporanea di 1 {currency} sulla carta. Non ti verrà addebitato nulla ora.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Il pagamento verrà effettuato presso la struttura.',
  'guest.noRoomsSelected': 'Nessuna camera selezionata.',
  'guest.noPropertySelected': 'Nessuna struttura selezionata.',
  'guest.paymentStillLoading':
    'Le opzioni di pagamento sono ancora in caricamento. Riprova tra un momento.',
  'guest.submitProcessing': 'Elaborazione…',
  'guest.submitVerifyCard': 'Verifica carta e conferma prenotazione',
  'guest.submitConfirm': 'Conferma prenotazione',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Pagamento',
  'payment.method': 'Metodo di pagamento',
  'payment.cardDetailsHint':
    'Inserisci i dati della carta in modo sicuro qui sotto. I dati della carta vengono tokenizzati e non arrivano mai ai nostri server.',
  'payment.loadingForm': 'Caricamento modulo di pagamento…',
  'payment.formUnavailable': 'Modulo di pagamento non disponibile.',
  'payment.acceptTerms': 'Accetto termini e condizioni e politica di cancellazione.',
  'payment.payNow': 'Paga ora',
  'payment.processing': 'Elaborazione…',
  'payment.noRoomsSelected': 'Nessuna camera selezionata.',
  'payment.redirecting': 'Reindirizzamento alla pagina di pagamento sicuro…',
  'payment.notConfigured': 'Quickstream non è configurato per questa struttura.',
  'payment.noScript':
    'Impossibile caricare il servizio di pagamento Quickstream. Aggiorna la pagina.',
  'payment.formNotLoaded': 'Modulo di pagamento non caricato. Aggiorna la pagina.',
  'payment.cardDetails': 'Pagamento non riuscito. Controlla i dati della carta.',
  'payment.tokenizationFailed': 'Tokenizzazione della carta non riuscita. Riprova.',
  'payment.failed': 'Pagamento non riuscito.',
  'payment.statusResult': 'Stato del pagamento: {status}. Riprova.',
  'confirmation.loading': 'Caricamento della tua prenotazione…',
  'confirmation.notFound': 'Prenotazione non trovata. Controlla il riferimento e riprova.',
  'confirmation.errorGeneric': "Impossibile confermare la prenotazione. Contatta l'assistenza.",
  'confirmation.errorLoadDetails': 'Impossibile caricare i dettagli della prenotazione.',
  'confirmation.couldNotComplete': 'Non siamo riusciti a completare il pagamento',
  'confirmation.startNew': 'Inizia una nuova prenotazione',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': "Sessione di pagamento non trovata. Contatta l'assistenza.",
  'confirmation.paymentStateInvalid':
    'Il pagamento non è in uno stato valido per essere completato. Ricomincia.',
  'confirmation.paymentFailedDeclined':
    'Impossibile completare il pagamento. Controlla i dati della carta e riprova, oppure usa un altro metodo di pagamento.',
  'confirmation.paymentTimeout': 'Il pagamento ha richiesto troppo tempo. Riprova.',
  'confirmation.paymentGatewayUnavailable':
    'Il sistema di pagamento è temporaneamente non disponibile. Riprova tra qualche istante.',
  'confirmation.paymentUnknown': 'Impossibile confermare il pagamento: {message}.',
  'confirmation.paymentGenericError':
    "Impossibile confermare il pagamento. Riprova o contatta l'assistenza.",
  'summary.title': 'Riepilogo della tua prenotazione',
  'summary.yourBooking': 'Riepilogo della tua prenotazione',
  'summary.noRoomsSelected': 'Nessuna camera selezionata.',
  'summary.checkIn': 'CHECK-IN',
  'summary.checkOut': 'CHECK-OUT',
  'summary.lengthOfStay': 'Durata del soggiorno',
  'summary.guests': 'Ospiti',
  'summary.nights': '{nights} notti',
  'summary.nights_one': '{nights} notte',
  'summary.nights_other': '{nights} notti',
  'summary.totalForNights': 'Totale per {nights} notti',
  'summary.includingTaxes': 'Tasse e commissioni incluse',
  'summary.discount': 'Risparmia {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Prenotazione confermata!',
  'detail.received': 'Prenotazione ricevuta',
  'detail.referenceIntro': 'Il tuo riferimento di prenotazione è',
  'detail.reservationId': 'Id prenotazione:',
  'detail.processing':
    "La tua prenotazione è in elaborazione. Riceverai un'email di conferma una volta confermato il pagamento.",
  'detail.guest': 'Ospite',
  'detail.rooms': 'Camere',
  'detail.night': 'notte',
  'detail.nights': 'notti',
  'detail.adult': 'adulto',
  'detail.adults': 'adulti',
  'detail.child': 'bambino',
  'detail.infant': 'infante',
  'detail.priceBreakdown': 'Dettaglio prezzi',
  'detail.subtotal': 'Subtotale',
  'detail.taxes': 'Tasse',
  'detail.fees': 'Commissioni',
  'detail.discounts': 'Sconti',
  'detail.surcharge': 'Sovrapprezzo carta',
  'detail.grandTotal': 'Totale complessivo',
  'priceBreakdown.roomSubtotal': 'Subtotale camera',
  'priceBreakdown.total': 'Totale',
  'detail.deposit': 'Deposito',
  'detail.depositDueBy': 'da pagare entro',
  'detail.arrival': 'arrivo',
  'detail.specialRequests': 'Richieste speciali',
  'detail.backToHome': 'Torna alla home',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Riprova',
  'shared.close': 'Chiudi',
  'shared.back': 'Indietro',
  'shared.previous': 'Precedente',
  'shared.next': 'Successivo',
  'validation.firstNameRequired': 'Il nome è obbligatorio',
  'validation.lastNameRequired': 'Il cognome è obbligatorio',
  'validation.emailRequired': 'Inserire un indirizzo email valido',
  'validation.phoneRequired': 'Il numero di telefono è obbligatorio',
  'validation.addressRequired': "L'indirizzo è obbligatorio",
  'validation.cityRequired': 'La città è obbligatoria',
  'validation.countryRequired': 'Il paese è obbligatorio',
  'validation.postalCodeRequired': 'Il codice postale è obbligatorio',
  'error.pmsUnavailable':
    "Spiacenti, questa camera non è più disponibile per le date selezionate. Torna indietro e scegli altre date o un'altra camera.",
  'error.pmsSyncError':
    'Impossibile connettersi con il sistema della struttura. Riprova tra qualche istante.',
  'error.paymentNotConfigured':
    "Il pagamento non è configurato per questa struttura. Scegli un'altra struttura o contatta l'assistenza.",
  'error.paymentStartFailed': "Qualcosa è andato storto durante l'avvio del pagamento. Riprova.",
  'error.bookingFailed': 'Prenotazione non riuscita. Riprova.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Prenota il tuo soggiorno',
  'site.title.suffix': 'Appartamenti e hotel',
  'site.title.home': 'Home',
  'site.title.search': 'Cerca',
  'site.title.property': 'Struttura',
  'site.title.room': 'Camera',
  'site.title.guestDetails': 'Dati ospite',
  'site.title.payment': 'Pagamento',
  'site.title.confirmation': 'Prenotazione confermata',
  'site.title.bookingLookup': 'Trova la tua prenotazione',
  'site.title.bookingDetails': 'Dettagli prenotazione',
  'site.title.cancellation': 'Annulla prenotazione',
  'site.title.reservationDetail': 'Dettagli prenotazione',
  'site.title.signIn': 'Accedi',
  'site.title.signUp': 'Registrati',
  'site.title.notFound': 'Pagina non trovata',
  'notFound.title': 'Pagina non trovata',
  'notFound.message': 'La pagina che stai cercando non esiste.',
  'notFound.backHome': 'Torna alla home',
  'home.heroAlt': 'Skyline di una città australiana',
  'home.featuredProperties': 'Strutture in evidenza',
  'home.popularDestinations': 'Destinazioni popolari',
  'common.reviews': '{count} recensioni',
  'common.reviews_one': '{count} recensione',
  'common.reviews_other': '{count} recensioni',
  'common.loading': 'Caricamento',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'di',
  'common.select': 'Seleziona…',
  'common.search': 'Cerca…',
  'common.selectLocation': 'Seleziona una località',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Nessuna opzione disponibile',
  'common.code': 'Codice',
  'common.searchCode': 'Cerca codice…',
  'filter.title': 'Filtri',
  'filter.price': 'Prezzo',
  'filter.priceMinimum': 'Minimo',
  'filter.priceMaximum': 'Massimo',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Tipo di struttura',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Appartamento',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Servizi',
  'filter.amenity.pool': 'Piscina',
  'filter.amenity.parking': 'Parcheggio',
  'filter.amenity.breakfast': 'Colazione inclusa',
  'filter.rating': 'Valutazione',
  'filter.rating.any': 'Qualsiasi valutazione',
  'filter.rating.5': '5 stelle',
  'filter.rating.4': '4 stelle e superiori',
  'filter.rating.3': '3 stelle e superiori',
  'filter.more': 'Altro',
  'filter.more.freeCancellation': 'Cancellazione gratuita',
  'filter.more.payAtProperty': 'Paga in struttura',
  'filter.clear': 'Cancella',
  'filter.apply': 'Applica filtri',
  'card.reviews_one': 'recensione',
  'card.reviews_other': 'recensioni',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Età 0 - 12',
  'auth.orContinueWith': 'Oppure continua con',
  'auth.signIn.title': 'Accedi al tuo account',
  'auth.signIn.subtitle':
    'Bentornato! Accedi per gestire le tue prenotazioni, visualizzare i tuoi soggiorni e accedere a offerte esclusive.',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Inserisci il tuo indirizzo email',
  'auth.emailRequired': "L'email è obbligatoria.",
  'auth.emailInvalid': 'Inserisci un indirizzo email valido.',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Inserisci la password',
  'auth.createPasswordPlaceholder': 'Crea una password',
  'auth.passwordRequired': 'La password è obbligatoria.',
  'auth.passwordMinLength': 'La password deve contenere almeno {min} caratteri.',
  'auth.passwordPattern': 'La password deve includere lettere e numeri.',
  'auth.passwordHint':
    'Usa almeno {min} caratteri con una combinazione di lettere, numeri e simboli.',
  'auth.showPassword': 'Mostra password',
  'auth.hidePassword': 'Nascondi password',
  'auth.keepSignedIn': 'Resta connesso',
  'auth.forgotPassword': 'Password dimenticata?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Accedi',
  'auth.signingIn': 'Accesso in corso...',
  'auth.signInError': 'Accesso non riuscito. Riprova.',
  'auth.googleError': 'Accesso con Google non riuscito.',
  'auth.noAccount': 'Non hai un account?',
  'auth.createAccount': 'Crea un account',
  'auth.signUp.title': 'Crea il tuo account',
  'auth.signUp.subtitle':
    'Iscriviti a {site} per gestire le tue prenotazioni, salvare le tue strutture preferite e ricevere offerte esclusive.',
  'auth.firstName': 'Nome',
  'auth.firstNamePlaceholder': 'Inserisci il tuo nome',
  'auth.firstNameRequired': 'Il nome è obbligatorio.',
  'auth.lastName': 'Cognome',
  'auth.lastNamePlaceholder': 'Inserisci il tuo cognome',
  'auth.lastNameRequired': 'Il cognome è obbligatorio.',
  'auth.mobile': 'Numero di cellulare',
  'auth.mobilePlaceholder': 'Inserisci il numero di cellulare',
  'auth.dialingCode': 'Prefisso internazionale',
  'auth.mobileRequired': 'Il numero di cellulare è obbligatorio.',
  'auth.mobileInvalid': 'Inserisci un numero di cellulare valido.',
  'auth.confirmPassword': 'Conferma password',
  'auth.confirmPasswordPlaceholder': 'Conferma la tua password',
  'auth.termsAgree': 'Accetto i',
  'auth.termsRequired': "Devi accettare i Termini e condizioni e l'Informativa sulla privacy.",
  'auth.marketingConsent': 'Vorrei ricevere offerte esclusive e ispirazione di viaggio da {site}',
  'auth.signUpError': "Impossibile creare l'account. Riprova.",
  'auth.signUp': 'Registrati',
  'auth.creatingAccount': 'Creazione account in corso...',
  'auth.createAccountButton': 'Crea account',
  'auth.alreadyHaveAccount': 'Hai già un account?',
  'auth.passwordMismatch': 'Le password non corrispondono.',
  'pricing.title': 'Riepilogo prezzi',
  'pricing.noRoomsSelected': 'Nessuna camera selezionata. Torna indietro e seleziona le camere.',
  'pricing.backToAvailability': 'Torna alla disponibilità',
  'pricing.continue': 'Continua ai dati ospite',
  'property.youSavePercent': 'Risparmi ({percent}% di sconto)',
  'property.includingTaxesFees': '(tasse e commissione incl.)',
  'map.zoomIn': 'Zoom avanti',
  'map.zoomOut': 'Zoom indietro',
  'map.viewFullMap': 'Vedi mappa completa',
  'booking.progress': 'Avanzamento prenotazione',
  'reservationDetail.resetAria': 'Reimposta stato prenotazione',
  'bookingLookup.title': 'Trova la tua prenotazione',
  'bookingLookup.description':
    "Inserisci il riferimento di prenotazione e l'email per visualizzare, modificare o annullare la tua prenotazione.",
  'bookingLookup.bookingReference': 'Riferimento prenotazione',
  'bookingLookup.placeholder': 'es. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Ricerca in corso…',
  'bookingLookup.findBooking': 'Trova prenotazione',
  'bookingLookup.notFound':
    'Prenotazione non trovata. Prova BK-2026-001, alex.morgan@example.com e Morgan.',
  'cancellation.title': 'Annulla prenotazione',
  'cancellation.property': 'Struttura',
  'cancellation.details': 'Dettagli cancellazione',
  'cancellation.penalty': 'Penale di cancellazione',
  'cancellation.refund': 'Importo rimborsato',
  'cancellation.totalPaid': 'Totale pagato:',
  'cancellation.reasonLabel': 'Motivo della cancellazione (opzionale)',
  'cancellation.understand': 'Sono consapevole che questa azione non può essere annullata.',
  'cancellation.cancelledDemo':
    "La tua prenotazione è stata annullata in questa demo dell'interfaccia. Importo rimborsato: {{refundAmount}}.",
  'cancellation.confirm': 'Conferma cancellazione',
  'cancellation.notFound': 'Prenotazione non trovata.',
  'bookingDetails.title': 'Dettagli prenotazione',
  'bookingDetails.notFound': 'Prenotazione non trovata.',
  'bookingDetails.checkIn': 'Check-in:',
  'bookingDetails.checkOut': 'Check-out:',
  'bookingDetails.rooms': 'Camere',
  'bookingDetails.guest': 'Ospite',
  'bookingDetails.freeCancellationUntil': 'Cancellazione gratuita fino al {date}',
  'bookingDetails.total': 'Totale:',
  'reservationDetail.loading': 'Caricamento della tua prenotazione…',
  'reservationDetail.noReference': 'Nessun riferimento di prenotazione fornito.',
  'reservationDetail.loadError': 'Impossibile caricare i dettagli della prenotazione.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Caricamento località…',
  'common.couldNotLoadLocations': 'Impossibile caricare le località',
  'common.searchLocationPlaceholder': 'Cerca paese, città o struttura',
  'common.collapse': 'Comprimi',
  'common.expand': 'Espandi',
  'map.loadingGoogle': 'Caricamento Google Map…',
  'map.errorGoogle': 'Impossibile caricare Google Maps',
  'map.errorMap': 'Impossibile caricare la mappa.',
  'map.greatLocation': 'Ottima posizione',
  'home.trust.secureBooking': 'Prenotazione sicura',
  'home.trust.secureBookingDesc': 'Le tue informazioni sono al sicuro con noi.',
  'home.trust.bestPrice': 'Garanzia del miglior prezzo',
  'home.trust.bestPriceDesc': 'Hai trovato un prezzo più basso? Lo eguaglieremo.',
  'home.trust.localSupport': 'Assistenza 24/7',
  'home.trust.localSupportDesc': 'Siamo qui per aiutarti in ogni momento.',
  'home.trust.flexibleBooking': 'Opzioni flessibili',
  'home.trust.flexibleBookingDesc': 'Cancellazione gratuita su tariffe selezionate.',
  'promotion.memberPromo': 'Promo socio',
  'promotion.save': 'Risparmia',
  'property.memberRate': 'Tariffa socio',
  'property.hideAmenities': 'Nascondi servizi',
  'property.showAllAmenities': 'Mostra tutti i servizi',
  'property.chooseRatePromo':
    'Scegli la tariffa preferita - Le tariffe socio offrono sconti esclusivi!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% di sconto',
  'gallery.imageAlt': '{title} vista {current} di {total}',
  'gallery.thumbnailAlt': 'Vai alla vista {current} di {total}',
  'gallery.previewAlt': 'Anteprima {title}',
  'detail.night_one': 'notte',
  'detail.night_other': 'notti',
  'detail.adult_one': 'adulto',
  'detail.adult_other': 'adulti',
  'detail.child_one': 'bambino',
  'detail.child_other': 'bambini',
  'detail.infant_one': 'infante',
  'detail.infant_other': 'infanti',
} as const;
